export interface BlurResult {
  variance: number;
  score: number;
  isTooBlurred: boolean;
}

// Tuned for 128×96 analysis canvas (downsampled from camera feed).
const BLUR_REJECT = 15;
const BLUR_ACCEPT = 80;

/**
 * Variance of Laplacian — measures high-frequency energy. Low variance = blurry.
 * Uses the 4-connected Laplacian kernel (0 1 0 / 1 -4 1 / 0 1 0).
 */
export function detectBlur(
  lums: Float32Array,
  w: number,
  h: number,
): BlurResult {
  let sumLap = 0,
    sumLapSq = 0;
  const count = (w - 2) * (h - 2);

  for (let row = 1; row < h - 1; row++) {
    for (let col = 1; col < w - 1; col++) {
      const i = row * w + col;
      const lap =
        lums[i - w] + lums[i + w] + lums[i - 1] + lums[i + 1] - 4 * lums[i];
      sumLap += lap;
      sumLapSq += lap * lap;
    }
  }

  const mean = sumLap / count;
  const variance = sumLapSq / count - mean * mean;
  const score = Math.min(
    1,
    Math.max(0, (variance - BLUR_REJECT) / (BLUR_ACCEPT - BLUR_REJECT)),
  );

  return { variance, score, isTooBlurred: variance < BLUR_REJECT };
}
